import React from "react";
import { observer } from "mobx-react";
import { PaymentReceiptCreateStore } from "../../store";
import { PaymentReceiptCreateForm } from "./PaymentReceiptCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PaymentReceiptCreateProps = {
  paymentReceiptCreateStore: PaymentReceiptCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PaymentReceiptCreate: React.FC<PaymentReceiptCreateProps> =
  observer(
    ({ paymentReceiptCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={paymentReceiptCreateStore.isSaving} />
          <PaymentReceiptCreateForm
            paymentReceiptCreateStore={paymentReceiptCreateStore}
            paymentReceiptOnRestoreFile={(id: string) =>
              paymentReceiptCreateStore.paymentReceiptRestoreFile(id)
            }
            paymentReceiptOnLoadFile={(file: any) =>
              paymentReceiptCreateStore.paymentReceiptUploadFile(file)
            }
            paymentReceiptOnCommitFile={(changes) =>
              paymentReceiptCreateStore.paymentReceiptCommitFile(changes)
            }
            paymentReceiptFiles={
              paymentReceiptCreateStore.entityValues.__paymentReceipt_files
            }
            paymentReceiptError={
              paymentReceiptCreateStore.errors.paymentReceipt?.message
            }
            typeError={paymentReceiptCreateStore.errors.type?.message}
            onTypeChange={(value) => {
              paymentReceiptCreateStore.setTypeValue(value);
            }}
            typeSelectedValue={paymentReceiptCreateStore.entityValues.showType}
            onTypeSelected={(value) => {
              paymentReceiptCreateStore.setSelectedType(value);
            }}
            typeOptions={paymentReceiptCreateStore.getTypeOptions()}
            amountError={paymentReceiptCreateStore.errors.amount?.message}
            onAmountChange={(value: number) => {
              paymentReceiptCreateStore.setAmountValue(value);
            }}
            amount={paymentReceiptCreateStore.entityValues.amount}
            issueDateTimeError={
              paymentReceiptCreateStore.errors.issueDateTime?.message
            }
            onIssueDateTimeChange={(value) => {
              paymentReceiptCreateStore.setIssueDateTimeValue(value);
            }}
            issueDateTime={paymentReceiptCreateStore.entityValues.issueDateTime}
            dummyCRUDRestoredObservable={
              paymentReceiptCreateStore.dummyCRUDRestoredObservable
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={paymentReceiptCreateStore.isProcessing}
            onSave={() => paymentReceiptCreateStore.saveNewPaymentReceipt()}
            onCancel={() => paymentReceiptCreateStore.cancelNewPaymentReceipt()}
          />
          <ErrorDialog
            open={paymentReceiptCreateStore.errorDialogOpened}
            title={paymentReceiptCreateStore.errorTitle}
            description={paymentReceiptCreateStore.errorDescription}
            onClose={() => paymentReceiptCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
